import * as types from "../../constants/actionTypes";

export const setLoader = (data) => {
  return {
    type: types.DASHBOARD_APOTEK_SET_LOADER,
    payload: data,
  };
};

export const getListReservasiApotek = (value) => {
  return {
    type: types.DASHBOARD_APOTEK_RESERVASI_RESEP_OBAT,
    value,
  };
};

export const getDetailReservasiApotek = (value, value2) => {
  return {
    type: types.DASHBOARD_APOTEK_RESERVASI_RESEP_OBAT_BY_ID,
    value,
    value2,
  };
};

export const finishResepObat = (value, history) => {
  return {
    type: types.DASHBOARD_APOTEK_RESERVASI_RESEP_OBAT_FINISH,
    value,
    history,
  };
};
